/* eslint-disable quotes */
export default {
  billing: 'Billing',
  cost_center: 'Cost Center',
  billing_overview: 'Overview',
  account_management: 'Account Management',
  billing_management: 'Bill Management',
  order_management: 'Order Management',
  total_balance: 'Account Balance',
  recharge: 'Pay Now',
  recharge_nav: 'Pay Now',
  withdrawal: 'Withdraw Balance',
  balance: 'Trans Details',
  cash_amount: 'Cash Amount',
  debt_cash: 'Debt Cash',
  freeze: 'Freeze',
  last_12_months: 'Consumption in the past 12 months',
  balance_overview: 'Expense Overview',
  month_end_balance: 'Account balance at the end of the month',
  last_month_end_balance: 'Balance at the end of last month',
  this_month_end_balance: 'Amount credited this month',
  month_this_balance: 'Amount spent this month',
  just_support_bank_transfer:
    'Currently, only corporate bank transfers are supported.',
  bill_expenses: 'Bill expenses',
  cash_withdrawal: 'Cash withdrawal',
  freeze_abbreviation: 'Freeze',
  total_income: 'Credited Amount',
  total_spending: 'Expenditure Amount',

  order_detail: 'Order Details',
  account_money_desc:
    'The amount remaining after the funds recharged into the account are consumed.',
  fee_Details: 'Details',
  post_paid_bill: 'Bill Expenses',
  pre_paid_service: 'Prepaid Service Expenses',
  withdrawal_fee_Details: 'Cash Withdrawal',
  freeze_money: 'Frozen amount',
  trading_hours: 'Transaction Time',
  serial_id: 'Serial Number',
  trading_money: 'Transaction Amount(¥)',
  income_and_expenditure_types: 'Type of Income and Expenditure',
  trading_types: 'Type of Transaction',
  trading_from: 'Transaction Channel',
  available_amount: 'Available Remaining Amount(¥)',
  bill_month: 'Bill Month',
  remark: 'Notes',
  transaction_type_freeze: 'Freeze',
  transaction_type_post_paid: 'Postpaid',
  transaction_type_pre_paid: 'Prepaid',
  transaction_type_withdrawal: 'Withdrawal',
  income: 'Credit',
  express: 'Expense',
  income_channel: 'Bank Transfer',
  express_channel: 'Balance Deduction',
  download_details: 'Download',
  download_all: 'Download All',
  balance_desc_1:
    'The income and expenditure details only show the changes in funds such as recharge, withdrawal, refund, and deduction of this account. If you need to view the specific resource consumption, you can visit the ',
  balance_desc_bill_details: 'bill details',
  balance_desc_2: ' for more information.',
  balance_desc_3:
    'Online query of detailed data for the past 18 months is supported. For historical income and expenditure details data exceeding 18 months, you can download the file to view locally. If the amount of data to be queried is too large, it is recommended to download and view it in split time periods.',
  balance_desc_4:
    'There may be a delay in the update of transaction data. Please be patient.',
  not_show_0_cost: "Don't display expenses of ¥0",
  current_month: 'This Month',
  last_month: 'Last Month',
  remittance_name: "Remitter's Name",
  remittance_bank: 'Remitting Bank',
  remittance_id: 'Remittance Account',
  remittance_money: 'Remittance Amount(¥)',
  remittance_time: 'Remittance Arrival Time',
  system_review: 'Under System Review',
  system_not_pass: 'Review Not Approved',
  recharging: 'Recharging in Progress',
  already_received: 'Funds Received',
  recharge_record: 'Remittance Records',
  recharge_record_title: 'Remittance Records',
  recharge_record_q:
    'Q: No recharge record was found on the remittance page. What should I do?',
  recharge_record_a:
    'A: First, please contact the bank to confirm whether the transfer was successful. If the transfer was successful but no record is shown on the remittance page, check whether the exclusive account number was entered incorrectly or incompletely according to the remittance voucher. If there is an error, please apply for a refund to the original account via email.',
  obtain_reference_id_fail: 'Failed to obtain remittance account',
  not_has_company_auth:
    'Please complete corporate verification before proceeding.',
  recharge_account_information: 'Receiving Account',
  account: 'Account',
  recharge_step: 'Remittance Process',
  recharge_step_one_title:
    'Confirm the name of the bank card account used for the remittance',
  recharge_step_one_desc_1: 'The recharge can be credited only when ',
  recharge_step_one_desc_2:
    "the actual remitter's name is consistent with the remitter's account name below.",
  recharge_step_one_desc_3: '',
  recharge_step_one_desc_4: 'Currently, only remittances in the name of ',
  recharge_step_one_desc_5: 'enterprise authentication',
  recharge_step_one_desc_6:
    'are supported. For any other needs, please contact the InGame platform.',
  recharge_step_two_title:
    "Remit the funds to the exclusive collection account of InGame through the remitter's account name shown above",
  recharge_step_two_desc_not_get_1:
    'Each account will be assigned a unique exclusive bank remittance account. Do not disclose it to others after obtaining it.',
  recharge_step_two_desc_not_get_2:
    "You haven't obtained the exclusive remittance account yet. Please click the button below to get it.",
  recharge_step_two_title_has:
    'The following is your exclusive remittance account for InGame. Please do not disclose it to others.',
  recharge_account_name: 'Beneficiary Name',
  recharge_account_company: 'Tencent Technology (Shenzhen) Co.Ltd',
  recharge_account_bank: 'Beneficiary Bank',
  recharge_account_bank_desc:
    'China Merchants Bank, Hanjing Center Branch, Shenzhen',
  recharge_account: 'Beneficiary Account',
  recharge_step_two_btn: 'Get the exclusive remittance account',
  recharge_step_three_title: 'Wait for the remittance amount to arrive',
  recharge_step_three_desc_1:
    "If the remitter's name and account information are both correct, the funds will arrive in as fast as 2 hours, or it may take up to 1 day. Please be patient.",
  recharge_step_three_desc_2:
    'We will notify you of the recharge result via email and internal message. You can also check the remittance details on the ',
  recharge_record_desc: 'remittance record',
  recharge_step_three_desc_3: ' page by yourself.',
  withdrawal_money: 'Withdraw the Balance',
  enter_money: 'Enter the amount',
  withdrawal_money_not_over:
    'The withdrawal amount cannot exceed the current balance',
  account_received: 'Account for Funds Receipt',
  come_back_to_payment_channel: 'Return to the Corresponding Payment Channel',
  withdrawal_apply_commit: 'Withdrawal Application Submitted',
  withdrawal_modal_content:
    'The cash withdrawal amount via corporate remittance is expected to be returned to your bank account within 7 to 15 working days.',
  apply_withdrawal_time: 'Application Time',
  withdrawal_money_and_icon: 'Withdrawal Amount(¥)',
  withdrawal_account: 'Withdrawal Account',
  recharge_update_time: 'Time of Recharge Arrival',
  draw_history_type_process: 'Applied',
  draw_history_type_process_desc:
    'The funds are expected to be credited to the account within 7 - 15 working days',
  draw_history_type_failed: 'Error',
  draw_history_type_completed: 'Succeed',
  draw_record: 'Recharge Records',
  draw_desc_content_1:
    'Withdrawals follow the "last - in - first - out" principle. The amount that has been consumed and its corresponding recharge record cannot be withdrawn.',
  draw_desc_content_2:
    '1. Withdrawal via Original Route: For amounts recharged ',
  days_range: 'within 360 days, ',
  draw_desc_content_3:
    'the funds can be returned to the original payment channel. The funds from corporate remittances are expected to be returned to the corresponding recharge account ',
  days_range_7_15: 'within 7 - 15 working days.',
  draw_desc_content_4: ' ',
  draw_desc_content_5: '2. Offline Withdrawal: For amounts recharged ',
  days_range_over: 'more than 360 days ago, ',
  draw_desc_content_6:
    'withdrawals cannot be made via the original recharge method. You can specify an account for withdrawal. The funds for offline withdrawals are expected to be returned to your account ',
  draw_desc_content_7: ' ',
  can_withdraw_money: 'Withdrawable Amount',
  withdraw_right_now: 'Withdraw Now',
  withdraw_record: 'Withdrawal Records',
  amount_not_zero: 'Withdrawal amount cannot be zero.',

  order_post: 'Post Paid Orders',
  order_id: 'Order Number',
  order_fee_mode: 'Billing Mode',
  order_post_fee: 'postpaid',
  order_game: 'Belonged Title',
  order_env: 'Belonged Environment',
  order_type: 'Bill Type',
  order_new_pay: 'New Purchase',
  order_renew: 'renew',
  order_create_time: 'Creation Time',
  order_creator: 'Creator',
  order_status: 'Status',
  order_price: 'Order Amount',
  order_produce: 'Product',
  order_sub_id: 'Sub-order ID',
  order_freeze_amount: 'Estimated Frozen Amount',
  order_operate_pay: 'Pay',
  order_pay_by_quantity: 'Pay-as-You-Go',
  order_pay_by_quantity_desc:
    'Suitable for businesses with significant fluctuations in demand',
  order_pay_by_quantity_warn: 'Notes on Pay-as-You-Go Mode:',
  order_pay_by_quantity_warn_1:
    '1. [Use First, Pay Later]You can use the product first, and fees will be deducted based on actual usage on the settlement date (usually the 1st of each month).',
  order_pay_by_quantity_warn_2_1:
    '2. [Funds Freeze] When activating Pay-as-You-Go (postpaid) resources, a portion of your account funds will be',
  order_pay_by_quantity_warn_2_2: ' freeze a portion of your account funds.',
  order_pay_by_quantity_warn_2_3:
    ' If your balance is less than the frozen amount, activation will not be possible.',
  order_pay_by_quantity_warn_3:
    '3. [Funds Unfreeze] When you release resources manually or due to account arrears, the frozen funds will be unfrozen.',
  order_pay_by_quantity_warn_4:
    '4. [Other] Frozen funds are not actually consumed and cannot be used while frozen. They will be available again after unfreezing.',
  order_pay_by_quantity_tips:
    'Estimated cost (i.e., frozen amount) based on manual assessment.',
  order_status_review: 'Cost Assessment in Progress',
  order_status_loading: 'Pending Confirmation',
  order_status_normal: 'Completed',
  order_status_cancel: 'Canceled',
  order_status_review_fail: 'Review Not Approved',
  order_completed: 'Order Transaction Completed',
  order_canceled: 'Order Canceled',
  order_review: 'Under Manual Assessment',
  order_wait_confirm: 'Order Pending Confirmation',
  order_review_fail: 'Order Review Not Approved',
  order_contact_us: 'Contact Us',

  order_pay_failed: 'Order Payment Failed',
  order_modal_confirm_title: 'Confirm Service Activation and Funds Freeze',
  order_modal_confirm_info:
    'Activating this service will freeze account funds ',
  order_modal_confirm_content_1:
    '1. When activating Pay-as-You-Go (postpaid) resources, a portion of your account funds will be frozen. Activation is not possible if your balance is less than the frozen amount.',
  order_modal_confirm_content_2:
    '2. When you release resources manually or due to account arrears, the frozen funds will be unfrozen.',
  order_modal_confirm_content_3:
    '3. Frozen funds are not actually consumed and cannot be used while frozen. They will be available again after unfreezing.',
  order_cancel_failed: 'Order Cancellation Failed',
  order_modal_cancel_title: 'Cancel This Order?',

  order_produce_service: 'Product Service',
  order_need_amount: 'Required Frozen Amount',
  order_modal_lack_title: 'Insufficient Account Balance to Activate Service',
  order_go_to_recharge: 'Go to Recharge',
  order_cancel_service: 'Do Not Activate Service for Now',
  order_in_progress:
    'Your order is being processed. Please wait patiently......',
  order_in_progress_desc:
    'You can refresh the order status later or check it in the order management.',
  order_done_desc: 'You can check it in the order management.',
  order_view_in_management: 'View Order',
  account_balance: 'Account Balance',

  service_shop: 'Service Selection',
  service_apply_estimate: 'Request Assessment',

  go_to_company_auth: 'Go to Studio Authentication',
  not_has_company_auth_desc:
    'Please complete the studio Authentication first before accessing this interface.',
  create_env_no_studio_auth:
    'Studio certification has not been completed, unable to create this type of environment',
  bill_internal_cert_desc:
    'The construction of the internal cost center is in progress. Stay tuned!',
  bill_intl_site_desc:
    'The construction of the international cost center is in progress. Stay tuned!',
  can_not_view_current_page: 'Unable to access',
  account_management_info: 'Account Info',
  account_management_id: 'Account ID',
  account_management_owned_by: 'Owned by',
  account_management_status: 'Account Status',
  account_management_status_active: 'Active',
  account_management_status_abnormal: 'Abnormal (Arrears)',
  account_management_status_Unauthenticated: 'Abnormal (Unauthenticated)',
  account_management_creation_time: 'Creation Time',
  account_management_assets: 'Account Assets',
  account_management_pay: 'Pay',
  account_management_withdrawal: 'Withdrawal',
  account_management_details: 'Details',
  account_management_admin: 'Account Admin',
  account_management_tips:
    'The following accounts can manage this account. In the studio organization, after assigning corresponding functional authorizations to the accounts, they can manage the corresponding functions on the account.',
  account_management_config: 'Go to Config',
  account_management_name: 'Name',
  account_management_group: 'Group',
  bill_management: 'Bill Management',
  bill_management_overview: 'Overview',
  bill_management_details: 'Details',
  bill_management_service: 'Service',
  bill_management_sub_service: 'Sub - Service',
  bill_management_title_env: 'Belonged Title & Env',
  bill_management_region: 'Region',
  bill_management_type: 'Bill Type',
  bill_management_mode: 'Billing Mode',
  bill_management_time_start: 'Start Using Time',
  bill_management_time_end: 'End Using Time',
  bill_management_amount_payable: 'Amount Payable (¥)',
  when_available_balance_less_than_threshold:
    'When the available balance is less than the threshold, a warning notification will be sent to the configured account email and in-site message, with daily reminders once (up to 5 consecutive days)',
  warning_threshold: 'Warning Threshold',
  currency_unit: 'Yuan',
  notification_scope: 'Notification Scope',

  bill_management_month_cost: 'Monthly Consumption',
  bill_management_statistical_cycle: 'Statistical Period',
  bill_management_to: 'To',
  bill_management_paid: 'Billed',
  bill_management_not_paid: 'Not Billed',
  bill_management_consumption_trend: 'Consumption Trend',
  bill_management_months: 'Last 6 Months',
  bill_management_year: 'Last Year',
  bill_management_product_based: 'Product-based Statistics',
  bill_management_game_based: 'Game Project-based Statistics',
  bill_management_billing_based: 'Billing Model-based Statistics',
  bill_management_product_name: 'Product Name',
  bill_management_game_project: 'Game Project',
  bill_management_game_name: 'Game Name',
  bill_management_billing_model: 'Billing Model',
  bill_management_amount: 'Amount',
  bill_management_proportion: 'Proportion',
  bill_management_annual: 'Annual/Monthly Subscription',
  bill_management_resource: 'Resource Pack',
  bill_management_usage: 'Usage-based Billing',
};
